import { jsx } from "react/jsx-runtime";
import ReplyIcon from "@mui/icons-material/Reply";
import { validateTidalLicense } from "../../base/index.js";
function Reply(props) {
  return /* @__PURE__ */ jsx(
    ReplyIcon,
    {
      "data-testid": "Reply",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Reply",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
Reply.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "Reply"
};
validateTidalLicense();
export {
  Reply
};
//# sourceMappingURL=Reply.js.map
